<template>
  <div class="ai-generate-footer d-flex align-items-center justify-content-between flex-nowrap gap-gd-1">
    <span
      class="credits-disclaimer fs-sa-12 fw-400 text-hint cursor-pointer"
      :title="$t('engine.aiGenerate.lblCreditDisclaimer', languageEngine)"
      v-b-tooltip.hover
    >
      {{ $t('engine.aiGenerate.lblCreditDisclaimer', languageEngine) }}
    </span>
    <!-- Credits Display -->
    <AIGenerateCreditDisplay
      class="flex-shrink-0"
      :used-this-time-label-class="usedThisTimeLabelClass"
      :msg-assistant="msgAssistant"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import AIGenerateCreditDisplay from './AIGenerateCreditDisplay.vue';
export default {
  name: 'AIGenerateFooter',
  components: {
    AIGenerateCreditDisplay
  },
  props: {
    usedThisTimeLabelClass: {
      type: String,
      default: 'text-default'
    },
    msgAssistant: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapGetters({
      languageEngine: 'designIframe/userPreference/languageEngine'
    })
  }
};
</script>

<style lang="scss" scoped>
.ai-generate-footer {
  width: 100%;
  .credits-disclaimer {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
